import { render } from "./InfoModalWindow.vue?vue&type=template&id=1c01024c&scoped=true"
import script from "./InfoModalWindow.vue?vue&type=script&lang=js"
export * from "./InfoModalWindow.vue?vue&type=script&lang=js"

import "./InfoModalWindow.vue?vue&type=style&index=0&id=1c01024c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c01024c"]])

export default __exports__